module.exports = __webpack_public_path__ + "static/005_Room-c036f90297fb557e9861d84756293901.jpg";